<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import './style.less'

export default {
}
</script>

<style lnag="less">
#app {
  height: 100%;
}
</style>
